/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../ISymbolData';
import ActivePaylineFilter from './Filters/ActivePaylineFilter';
import StreakTrackerRuleBase from './StreakTrackerRuleBase';

/** Rule for determining scatter symbols on paylines. */
@cc._decorator.ccclass
export default class PaylineScatterSymbolCountRule extends StreakTrackerRuleBase
{
    /** @hidden */
    private _paylineFilter: ActivePaylineFilter = null;
    /** @hidden */
    private get paylineFilter(): ActivePaylineFilter
    {
        if (!this._paylineFilter)
        {
            this._paylineFilter = this.addComponent(ActivePaylineFilter);
        }

        return this._paylineFilter;
    }

    /** Filters out those not on payline. */
    protected applyRuleFilter(): ISymbolData[]
    {
        return this.paylineFilter.Filter(this.validSymbols);
    }
}
